<template>
  <div>
    <div class="header page-header">
      <div>INVOICE</div>
      <p>Create new invoice</p>
    </div>
    <div>
      <h5 class="primary-color sub-title">CUSTOMER DATA</h5>
      <div class="card form form--inline">
        <div class="form__group">
          <label>Choose Customer <span style="color: #ff5e5e;">*</span></label>
          <Multiselect
            class="input  input--dropdown input__underline"
            :disabled="$route.query.customer"
            v-model="customer"
            :select-label="'✔'"
            :deselect-label="'X'"
            :options="customers"
            track-by="name"
            label="name"
            v-bind:class="{err: errors.customer_id}"
          ></Multiselect>
          <!--<div v-if="errors.customer_id">{{Array.isArray(errors.customer_id) ? errors.customer_id[0]: errors.customer_id}}</div>-->
        </div>
        <div class="form__group">
          <label>Phone</label>
          <input class="input input__underline" disabled v-model="customer.phone" v-bind:class="{err: errors.phone}">
        </div>
        <div class="form__group">
          <label>Name</label>
          <input class="input input__underline" disabled v-model="customer.name" v-bind:class="{err: errors.name}">
        </div>
        <div class="form__group">
          <label>Customer Address</label>
          <input class="input input__underline" disabled v-model="customer.address" v-bind:class="{err: errors.address}">
        </div>
      </div>
    </div>
    <div>
      <h5 class="primary-color sub-title">INVOICE DATA</h5>
      <div class="card">
        <div class="form form--inline">
          <div class="form__group">
            <label >Invoice Number <span style="color: #ff5e5e;">*</span></label>
            <input class="input input__underline" v-model="invoice.invoice_number" v-bind:class="{err: errors.invoice_number}">
            <!--<div-->
              <!--v-if="errors.invoice_number"-->
            <!--&gt;{{Array.isArray(errors.invoice_number) ? errors.invoice_number[0]: errors.invoice_number}}</div>-->
          </div>
          <div class="form__group">
            <label>Delivery Date <span style="color: #ff5e5e;">*</span></label>
            <Datepicker
              class="input input__underline input--calendar-invoice"
              v-model="invoice.delivery_date"
              @input="openDatepicker('delivery_date')"
              format="dd.MM.yyyy"
              v-bind:class="{err: errors.delivery_date}"
            ></Datepicker>
            <!--<div-->
              <!--v-if="errors.delivery_date"-->
            <!--&gt;{{Array.isArray(errors.delivery_date) ? errors.delivery_date[0]: errors.delivery_date}}</div>-->
          </div>
          <div class="form__group">
            <label>Merchant Contact Name</label>
            <input class="input input__underline" v-model="invoice.merchant_contact_name">
          </div>
          <div class="form__group">
            <label>Delivery address</label>
            <input class="input input__underline" v-model="invoice.delivery_address">
          </div>
        </div>
        <div class="form form--inline">
          <div class="form__group">
            <label>Merchant Order Number</label>
            <input class="input input__underline" v-model="invoice.merchant_order_number">
          </div>
          <div class="form__group">
            <label>Due Date <span style="color: #ff5e5e;">*</span></label>
            <Datepicker
              class="input input__underline input--calendar-invoice"
              v-model="invoice.due_date"
              @input="openDatepicker('due_date')"
              format="dd.MM.yyyy"
              v-bind:class="{err: errors.due_date}"
            ></Datepicker>
            <!--<div-->
              <!--v-if="errors.due_date"-->
            <!--&gt;{{Array.isArray(errors.due_date) ? errors.due_date[0]: errors.due_date}}</div>-->
          </div>
          <div class="form__group">
            <label>Comment</label>
            <input class="input input__underline" v-model="invoice.comment">
          </div>
          <div class="form__group">
            <label>Buyer order number</label>
            <input class="input input__underline" v-model="invoice.buyer_order_number">
          </div>
        </div>
        <div class="form form--inline">
          <div class="form__group">
            <label>Payment Reference</label>
            <input class="input input__underline" v-model="invoice.payment_reference"
                   placeholder="Max length 20 chars"
                   maxlength="20"
                   v-bind:class="{err: errors.payment_reference}">
          </div>
          <div class="form__group">
            <label>Issue Date <span style="color: #ff5e5e;">*</span></label>
            <Datepicker
              class="input input__underline input--calendar-invoice"
              v-model="invoice.issue_date"
              @input="openDatepicker('issue_date')"
              format="dd.MM.yyyy"
              v-bind:class="{err: errors.issue_date}"
            ></Datepicker>
            <!--<div-->
              <!--v-if="errors.issue_date"-->
            <!--&gt;{{Array.isArray(errors.issue_date) ? errors.issue_date[0]: errors.issue_date}}</div>-->
          </div>
          <div class="form__group">
            <label>Order Date <span style="color: #ff5e5e;">*</span></label>
            <Datepicker
              class="input input__underline input--calendar-invoice"
              v-model="invoice.order_date"
              @input="openDatepicker('order_date')"
              format="dd.MM.yyyy"
              v-bind:class="{err: errors.order_date}"
            ></Datepicker>
            <!--<div-->
              <!--v-if="errors.order_date"-->
            <!--&gt;{{Array.isArray(errors.order_date) ? errors.order_date[0]: errors.order_date}}</div>-->
          </div>
          <div class="form__group">
            <label>Invoice URL</label>
            <input class="input input__underline" v-model="invoice.invoice_url">
          </div>
        </div>
      </div>

      <div>
        <h5 class="primary-color sub-title">INVOICE LINES</h5>
        <div class="card">
          <table style="width:100%">
            <col width="7%">
            <col width="15%">
            <col width="12%">
            <col width="7%">
            <col width="7%">
            <col width="7%">
            <col width="7%">
            <col width="7%">
            <col width="12%">
            <col width="12%">
            <col width="7%">
            <tr style="background-color: #f9f9fa">
              <th>Number<span style="color: #ff5e5e;">*</span></th>
              <th>Article Description<span style="color: #ff5e5e;">*</span></th>
              <th>Unit<span style="color: #ff5e5e;">*</span></th>
              <th>Quantity<span style="color: #ff5e5e;">*</span></th>
              <th>Price Per Unit<span style="color: #ff5e5e;">*</span></th>
              <th>VAT Rate<span style="color: #ff5e5e;">*</span></th>
              <th>Total Vat Amount<span style="color: #ff5e5e;">*</span></th>
              <th>Total Price (incl. VAT)<span style="color: #ff5e5e;">*</span></th>
              <th>Price Reduction<span style="color: #ff5e5e;">*</span></th>
              <th>Discount<span style="color: #ff5e5e;">*</span></th>
              <th></th>
            </tr>
            <tr
              v-for="(invoiceLine,index) in invoiceLines"
              :key="invoiceLine.id"
              class="table-row fixed-inputs"
            >
              <td>
                <input
                  class="input input__underline"
                  v-model="invoiceLines[index].article_number"
                  type='number'
                  v-bind:class="(errors.articles[index] && errors.articles[index].article_number) ? 'err' : ''"
                  v-bind:placeholder="errors.articles[index] && errors.articles[index].article_number || ' '"
                ></td>
              <td>
                <input
                  class="input input__underline"
                  v-model="invoiceLines[index].article_description"
                  v-bind:class="(errors.articles[index] && errors.articles[index].article_description) ? 'err' : ''"
                  v-bind:placeholder="errors.articles[index] && errors.articles[index].article_description || ' '"
                ></td>
              <td>
                <input
                  class="input input__underline"
                  v-model="invoiceLines[index].unit"
                  v-bind:class="(errors.articles[index] && errors.articles[index].unit) ? 'err' : ''"
                  v-bind:placeholder="errors.articles[index] && errors.articles[index].unit || ' '"
                ></td>
              <td>
                <input
                  class="input input__underline"
                  v-model="invoiceLines[index].quantity"
                  type='number'
                  v-bind:class="(errors.articles[index] && errors.articles[index].quantity) ? 'err' : ''"
                  v-bind:placeholder="errors.articles[index] && errors.articles[index].quantity || ' '"
                ></td>
              <td>
                <input
                  class="input input__underline"
                  v-model="invoiceLines[index].price_per_unit"
                  type='number'
                  v-bind:class="(errors.articles[index] && errors.articles[index].price_per_unit) ? 'err' : ''"
                  v-bind:placeholder="errors.articles[index] && errors.articles[index].price_per_unit || ' '"
                ></td>
              <td>
                <input
                  class="input input__underline"
                  v-model="invoiceLines[index].vat_rate"
                  type='number'
                  v-bind:class="(errors.articles[index] && errors.articles[index].vat_rate) ? 'err' : ''"
                  v-bind:placeholder="errors.articles[index] && errors.articles[index].vat_rate || ' '"
                ></td>
              <td>
                <input
                  class="input input__underline"
                  v-model="invoiceLines[index].total_vat_amount"
                  type='number'
                  v-bind:class="(errors.articles[index] && errors.articles[index].total_vat_amount) ? 'err' : ''"
                  v-bind:placeholder="errors.articles[index] && errors.articles[index].total_vat_amount || ' '"
                ></td>
              <td>
                <input
                  class="input input__underline"
                  v-model="invoiceLines[index].total_price_including_vat"
                  type='number'
                  v-bind:class="(errors.articles[index] && errors.articles[index].total_price_including_vat) ? 'err' : ''"
                  v-bind:placeholder="errors.articles[index] && errors.articles[index].total_price_including_vat || ' '"
                ></td>
              <td>
                <input
                  class="input input__underline"
                  v-model="invoiceLines[index].price_reduction"
                  type='number'
                  v-bind:class="(errors.articles[index] && errors.articles[index].price_reduction) ? 'err' : ''"
                  v-bind:placeholder="errors.articles[index] && errors.articles[index].price_reduction || ' '"
                ></td>
              <td>
                <input
                  class="input input__underline"
                  v-model="invoiceLines[index].price_discount"
                  type='number'
                  v-bind:class="(errors.articles[index] && errors.articles[index].price_discount) ? 'err' : ''"
                  v-bind:placeholder="errors.articles[index] && errors.articles[index].price_discount || ' '"
                ></td>
              <td>
                <span v-if="index > 0" @click="removeLine(index)">
                  <i class="pg pg-delete color-fail" style="cursor: pointer; font-size: 22px"/>
                </span>
              </td>
            </tr>
          </table>
          <div class="form form--spaced" v-if="errors.no_line">{{errors.no_line}}</div>

          <div class="form">
            <button typeof="button" class="btn btn__small sub-title" @click="addLine">+ add new line</button>
          </div>
        </div>
      </div>
    </div>
    <div class="submit form form--spaced">
      <div class="form__group form__group--spaced">
        <label>Total VAT amount(calculated)</label>
        <input class="input input__underline" disabled v-bind:value="totalVatAmount">
      </div>
      <div class="form__group">
        <label>Total amount(calculated)</label>
        <input class="input input__underline" disabled v-bind:value="totalAmount">
      </div>

      <div style="margin-top: 16px">
        <Button class="btn btn__primary" text="Send" @on-click="createInvoice"/>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import moment from "moment";
import Button from "../partials/Button.vue";
import { fetchCustomers, fetchCustomer } from "../customers/api.js";
import * as api from "./api.js";
import * as validation from "./validations.js";

export default {
  name: "CreateInvoice",
  components: {
    Datepicker,
    Button,
    Multiselect
  },
  created: async function() {
    document.title = 'Add Invoice | PayGate Invoice'
    if (this.$route.query.customer) {
      this.customer = await fetchCustomer(this.$route.query.customer, 1,{value: 'first_name' , direction: 'asc'});
    } else {
      let response = await fetchCustomers({
        per_page: 100000,
        sort: {
          value: 'created_at',
          direction: 'asc'
        }});
      this.customers = response.data;
    }
  },
  methods: {
    addLine() {
      this.invoiceLines.push({});
    },
    removeLine(index) {
      this.invoiceLines.splice(index, 1);
    },
    openDatepicker(field) {
      console.log("open datepicker");
      this.datePickerOpened[field] = true;
    },
    createInvoice: async function() {
      let response;
        this.errors = { articles: [] }
      let invoice = {
        invoice_articles: this.invoiceLines,
        customer_id: this.customer.id,
        ...this.invoice,
        delivery_date: moment(this.invoice.delivery_date).format("DD.MM.YYYY"),
        order_date: moment(this.invoice.order_date).format("DD.MM.YYYY"),
        due_date: moment(this.invoice.due_date).format("DD.MM.YYYY"),
        issue_date: moment(this.invoice.issue_date).format("DD.MM.YYYY"),
        total_amount: this.totalAmount,
        total_vat_amount: this.totalVatAmount
      };
      const { isValid, errors } = validation.invoice({
        ...invoice,
        datePickerOpened: this.datePickerOpened
      });
      console.log(errors, invoice, isValid);
      if (!isValid) {
        this.errors = errors;
        this.$toasted.error(
          "All highlighted fields are required.",
          { className: "error-toast" }
        );
        return;
      }
      try {
        response = await api.createInvoice(invoice)
        this.errors = { articles: [] }
        this.$toasted.success(
          "Invoice added successfully",
          { className: "success-toast" }
        );

        this.$router.push("/dashboard/invoices")
      } catch (e) {
        this.errors = { articles: [] }
        this.error = "error"
        let err_msg = "Something went wrong"
        if (e.response && e.response.data && e.response.data.message) {
          let msg = e.response.data.message
          if (msg[0] === "\""){
            msg = msg.replace("\"", '')
            msg = msg.replace("\"", '')
          }
          this.$toasted.error(
            msg,
            { className: "error-toast" }
          )
        } else {
          Object.keys(e.response.data.errors).map(
            key => {
              if (e.response.data.errors[key]) {
                err_msg = e.response.data.errors[key][0]
            }
          })
          this.$toasted.error(err_msg, { className: "error-toast" });
        }}
    }
  },
  computed: {
    totalVatAmount: function() {
      let sum = 0;
      this.invoiceLines.forEach(invoiceLine => {
        sum += Number(invoiceLine.total_vat_amount || 0);
      });
      return sum;
    },
    totalAmount: function() {
      let sum = 0;
      this.invoiceLines.forEach(invoiceLine => {
        sum += Number(invoiceLine.total_price_including_vat || 0);
      });
      return sum;
    }
  },
  data() {
    return {
      invoiceLines: [{}],
      customers: [],
      customer: { name: "" },
      invoice: {},
      errors: { articles: [] },
      datePickerOpened: {}
    };
  }
};
</script>

<style lang="scss" scoped>
.invoice-row {
  display: flex;
}
.sub-title {
  font-family: Montserrat-SemiBold;
}

.bottom-details {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.submit {
  width: 280px;
  border: 0;
  margin-left: auto;
  input,
  .btn {
    width: 100%;
  }

  & > * {
    width: 100%;
  }
}
</style>
